// extracted by mini-css-extract-plugin
export default {"input":"Q--z","button":"R--z","selected":"S--z","unavailable":"T--z","oos":"U--z","image":"V--z","paperCutDisabledOverlay":"W--z"};